module.exports = "pegasus_template/assets/theme3/l_w.png";